import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UserBloc } from '@kp/user/user.bloc';

@Component({
  selector: 'kp-modal-email-verification-required',
  templateUrl: './modal-email-verification-required.component.html',
  styleUrls: ['./modal-email-verification-required.component.scss'],
})
export class ModalEmailVerificationRequiredComponent {
  @Input() email: string;
  @Input() returnUrl: string;
  @Output() closeClicked = new EventEmitter<boolean>();

  callInProgress = false;
  showError = false;

  constructor(private _router: Router, private _userBloc: UserBloc) {}

  dismissModal() {
    this.closeClicked.emit(true);
  }

  confirmEmail() {
    this.callInProgress = true;
    this._userBloc.signUp(this.email);
    void this._router.navigate(['/welcome/signup/verification/email']);
  }
}
